import { render, staticRenderFns } from "./WalletV3.vue?vue&type=template&id=7ffa70de&scoped=true"
import script from "./WalletV3.vue?vue&type=script&lang=js"
export * from "./WalletV3.vue?vue&type=script&lang=js"
import style0 from "./WalletV3.vue?vue&type=style&index=0&id=7ffa70de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ffa70de",
  null
  
)

export default component.exports